import*as e from"react";import r from"./index.module.scss.js";var s=function(){return e.createElement("span",{className:r.requiredAsterix},"*")};export{s as RequiredAsterix};
//# sourceMappingURL=RequiredAsterix.js.map
